import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { ToolbarButton } from '@blueprism/ui-core';
import { SaveFloppyDisk } from '@blueprism/ui-icons';

import { SpinnerIcon } from 'app-image-loading';
import { MODAL_MODES } from 'app-modal';

export const BaseFormSubmitToolbarButton = ({
  active,
  'data-testid': dataTestId,
  disableCheckDirty,
  icon,
  label,
  mode,
}) => {
  if (mode === MODAL_MODES.VIEW) return null;

  const { dirty, isSubmitting, isValid } = useFormikContext();
  const { t } = useTranslation();
  const isFormValid = disableCheckDirty ? isValid : isValid && dirty;

  const isDisabled = isSubmitting || !isFormValid;

  return (
    <ToolbarButton
      data-testid={dataTestId}
      active={active}
      type="submit"
      icon={isSubmitting ? <SpinnerIcon /> : icon}
      disabled={isDisabled}
      label={t(label)}
    />
  );
};

BaseFormSubmitToolbarButton.propTypes = {
  disableCheckDirty: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.element,
  mode: PropTypes.string,
  'data-testid': PropTypes.string,
  active: PropTypes.bool,
};

BaseFormSubmitToolbarButton.defaultProps = {
  disableCheckDirty: false,
  label: 'SAVE',
  mode: null,
  'data-testid': '',
  active: false,
  icon: <SaveFloppyDisk />,
};
